/**
 * ポイント
 * あらかじめ、使用する文字列は決めておく
 */

export const CALC_PARAM = {
  PLUS: '+',
  MINUS: '-',
  MULTIPLY: 'x',
  DIVIDE: '÷',
  EQUAL: '=',
  CLEAR: 'AC', 
};
